import ScrollView from 'devextreme-react/scroll-view';

export function CEClientsListPage() {
  return (
    <ScrollView>
      <div style={{ padding: '1rem 1.25rem' }}>
        <h2>CE Clients List</h2>
        <p>Sales CE client tracking will live here. Requires the OpsSales or ItSysAdmin App Role.</p>
      </div>
    </ScrollView>
  );
}
